export const customEasing: { smooth: [number, number, number, number]; bounce: [number, number, number, number] } = {
  smooth: [0.16, 1, 0.3, 1],
  bounce: [0.68, -0.55, 0.265, 1.55],
};
